import { Skeleton } from '@mui/material'

export default function LoadableControl(props = {}) {
  return props.loading ? <Skeleton sx={{height: '100% !important'}} variant="rounded" fullWidth /> : props.children
}